<template>
    <v-main>
        <v-layout fill-height column>
            <v-container flex-fill fluid>
                <div class="d-flex flex-column justify-center align-center fill-height pb-20">
                    <img :src="getImage('ic_firecracker.svg')" class="mb-2">
                    <div class="fs-18 blueGrayDarken4--text text-center">
                        모든 준비가 되었습니다.<br />
                        여행을 시작해볼까요?
                    </div>
                </div>
            </v-container>
            <div class="footer-btns">
                <BlackBtn x-large str="시작하기" @click="goLoginPage"/>
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
export default {
    data: () => ({
		travelApplStepCd :'0001',
		type:'S'
    }),
    components: {
        BlackBtn,
    },
	methods :{
		goTravelPage() {
			// travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
			// startType = 단계별 처음(S), 단계별 다시시작(R)
			// 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
			this.$router.push({
				name: "travelIntro",
				query: {travelApplStepCd: this.travelApplStepCd, startType: this.type, isSuitcase: false}
			});
		},
        goLoginPage () {
			window.location.href = '/user/login'
		}

	},
}
</script>
<style lang="scss" scoped>
.v-input::v-deep {
    .v-text-field__details {
        padding-left: 0;
    }
}
.complete {

}
</style>
